import React from 'react';
import { useDispatch } from 'react-redux';

import DropdownMenu from '../../../ui/DropdownMenu';

import { clearUserData } from '../../../../services/localSorage';
import { resetPrivacyState } from '../../../../services/notification';

import { resetState as resetOnboardingState } from '../../../../store/onboarding/actions';
import { resetState as resetUserState } from '../../../../store/user/actions';
import { resetState as resetSNGPCState } from '../../../../store/sngpc/actions';

import { useDropdown } from '../../../../hooks';

import * as Styles from './UserContainerStyles';

interface Props {
  user: string;
  drugStore: string;
}

const UserContainer: React.FC<Props> = ({ user, drugStore }: Props) => {
  const dispatch = useDispatch();

  const { showMenu, toggleMenu } = useDropdown();

  const handleLogout = (): void => {
    clearUserData();
    dispatch(resetUserState());
    dispatch(resetOnboardingState());
    dispatch(resetSNGPCState());
    resetPrivacyState();
  };

  return (
    <Styles.Container>
      <Styles.Button
        type="button"
        className={showMenu.user ? 'active' : ''}
        onClick={(): void => toggleMenu('user')}
        id="dropdown-container-user"
        data-testid="dropdown-container-user"
      >
        <Styles.Icon name="user" />
      </Styles.Button>

      <DropdownMenu open={showMenu.user}>
        <Styles.List>
          <Styles.Item>
            <h6>{drugStore}</h6>
            <p>{user}</p>
          </Styles.Item>
          <Styles.Item className="is-hoverable">
            <Styles.Link to="/login" onClick={handleLogout}>
              <Styles.Icon name="share" />
              <p>Sair</p>
            </Styles.Link>
          </Styles.Item>
        </Styles.List>
      </DropdownMenu>
    </Styles.Container>
  );
};

export default UserContainer;
